import { render } from "./product-packages.vue?vue&type=template&id=2f7d2890&scoped=true"
import script from "./product-packages.vue?vue&type=script&lang=js"
export * from "./product-packages.vue?vue&type=script&lang=js"

import "./product-packages.vue?vue&type=style&index=0&id=2f7d2890&lang=css"
import "./product-packages.vue?vue&type=style&index=1&id=2f7d2890&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7d2890"]])

export default __exports__